/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAddressData
 */
export interface CreateAddressData {
    /**
     * 
     * @type {string}
     * @memberof CreateAddressData
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressData
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressData
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressData
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressData
     */
    postalCode: string;
    /**
     * A 2-letter country code, must conform to ISO 3166-1 Alpha-2
     * @type {string}
     * @memberof CreateAddressData
     */
    countryCode: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAddressData
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAddressData
     */
    longitude?: number | null;
}

/**
 * Check if a given object implements the CreateAddressData interface.
 */
export function instanceOfCreateAddressData(value: object): value is CreateAddressData {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function CreateAddressDataFromJSON(json: any): CreateAddressData {
    return CreateAddressDataFromJSONTyped(json, false);
}

export function CreateAddressDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAddressData {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'],
        'region': json['region'] == null ? undefined : json['region'],
        'postalCode': json['postalCode'],
        'countryCode': json['countryCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

  export function CreateAddressDataToJSON(json: any): CreateAddressData {
      return CreateAddressDataToJSONTyped(json, false);
  }

  export function CreateAddressDataToJSONTyped(value?: CreateAddressData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'region': value['region'],
        'postalCode': value['postalCode'],
        'countryCode': value['countryCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

